import { getLimitOptions } from 'utilities/query';
import templateUrl from './company-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    query: '<',
    companies: '<',
    userLockoutChanged: '&',
    queryChanged: '&',
    searchTextChanged: '&',
    complianceChanged: '&'
  },
  controller: class CompanyListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });

      this.onPaginationChanged = (page, take) => {
        this.onQueryChange({
          ...this.query,
          page,
          take
        });
      };

      this.onOrderChanged = (order) => {
        const direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        const orderBy = order.replace('-', '');

        this.onQueryChange({
          ...this.query,
          direction,
          orderBy
        });
      };
    }

    $onInit() {
      this.limitOptions = getLimitOptions();
    }

    onQueryChange(query) {
      this.queryChanged(
        this.EventEmitter({
          query
        })
      );
    }

    onSearchTextChanged(searchText) {
      this.searchTextChanged(
        this.EventEmitter({
          searchText
        })
      );
    }

    onComplianceChanged(company) {
      this.complianceChanged(
        this.EventEmitter({
          company
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/companies/company-list/company-list.component.js